import { render, staticRenderFns } from "./ThankYou.vue?vue&type=template&id=23d56560&scoped=true"
var script = {}
import style0 from "./ThankYou.vue?vue&type=style&index=0&id=23d56560&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d56560",
  null
  
)

export default component.exports